export default "__VITE_PUBLIC_ASSET__036904aa__"